<!-- {{ "how_can_we_help" | langVal }} -->
<!-- <h2>לצערנו לא ניתן לשלוח אימייל כרגע, אנא נסו שנית מאוחר יותר</h2> -->
<!-- <h3>ניתן ליצור קשר בווטסאפ 054-424408</h3> -->
<div>
	<p>{{ "check_faq" | langVal }}</p>
</div>
<div style="height: calc(100svh - 374px); min-height: 400px">
	<iframe
		height="100%"
		width="100%"
		src="https://www.my-cliniq.com/frequentlyaskedquestions/"
		[frameBorder]="0"
	></iframe>
	<!--  style="height: calc(100svh - 478px);"-->
</div>
<div class="row">
	<div class="col-12">
		<app-gen-input
			tabindex="-1"
			[actualObj]="errorModalForm"
			[errors]="errors"
			fieldName="subject"
			(keyupEvent)="validateEntireForm()"
		>
		</app-gen-input>
	</div>
</div>
<div class="row">
	<div class="col-12">
		<app-gen-input
			tabindex="-1"
			type="textarea"
			[actualObj]="errorModalForm"
			[errors]="errors"
			fieldName="announcement"
			title_ph_lang="announce"
			(keyupEvent)="validateEntireForm()"
		>
		</app-gen-input>
	</div>
</div>
{{ "please_leave_contact_details" | langVal }}
<div class="row">
	<div class="col-6">
		<app-gen-input
			[actualObj]="errorModalForm"
			fieldName="email"
			[errors]="errors"
			[addonObject]="{ after: { icon: 'email' } }"
			(keyupEvent)="validateEntireForm()"
		></app-gen-input>
	</div>
	<div class="col-6">
		<app-gen-input
			[actualObj]="errorModalForm"
			fieldName="phone"
			[errors]="errors"
			[addonObject]="{ after: { icon: 'phone' } }"
			(keyupEvent)="validateEntireForm()"
		></app-gen-input>
	</div>
</div>

<div class="modal-btns">
	<app-cancel-btn (click)="onClose.emit()" />
	<app-btn-ext
		[disabled]="!isFormSubmittable"
		(clickEv)="sendErrorEmail()"
		text="confirm"
	/>
</div>
